import React, { FunctionComponent } from 'react';
import Hint from 'src/ui/atoms/hint';
import Spacer from 'src/ui/atoms/spacer';
import Translate from 'src/ui/atoms/translate';

const AddProductSuccess: FunctionComponent<{ isEwpg: boolean }> = ({ isEwpg }) => {
  return (
    <>
      <Hint variant="success">
        <Translate name="addProduct.success.hintSuccess" />
      </Hint>
      {isEwpg && (
        <>
          <Spacer y={4} />
          <Hint variant="info">
            <Translate name="addProduct.success.hintInfo" />
          </Hint>
        </>
      )}
    </>
  );
};

export default AddProductSuccess;
